<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="已下单" :value="0"></el-option>
          <el-option label="已结束" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>{{ $getLabel(typeList, row.type) }}</div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="info" size="small" v-if="row.status === 0">已下单</el-tag>
          <el-tag type="success" size="small" v-if="row.status === 1"
            >已结束</el-tag
          >
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" @click="toOrder(row)">查看订单</el-button>
        </div>
      </template>
    </auto-table>
  </div>
</template>

<script>
import { typeList, statusList, ilkList } from "./components/type.js";
export default {
  data() {
    return {
      typeList,
      DataList: [],
      Option: [
        { name: "商品名称", value: "title" },
        { name: "购买方", value: "name" },
        { name: "电话", value: "phone" },
        { name: "类型", value: "type" ,type: "custom" },
        { name: "状态", value: "status", type: "custom" },
        { name: "下单时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 0,
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    toOrder(row){
      this.$router.push({
        name:'orderDetails',
        params:{
          id:row.order_no
        }
      })
    },
    updateStatus(row,status){
        if(status == 2){
          if(new Date(row.end_time).getTime() < Date.now()){
            this.$message("活动已结束，不能上架")
            return
          }
        }

        this.$post('/user/businessActivityType/update',{id:row.id,status}).then(res=>{
          this.getList(1);
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/productRecord/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>